<section
  class="content-card-grid-shell"
  [class.operator-home-grid-shell]="variant === 'operator-home'"
  [class.workflow-card-list-shell]="variant === 'workflow-card-list'"
  [style.max-width]="maxWidth">
  <ng-container *ngIf="variant === 'workflow-card-list'; else standardSectionTitleTpl">
    <header class="workflow-list-header" *ngIf="sectionTitle || sectionSubtitle || searchPlaceholder">
      <div class="workflow-list-title-group">
        <h2 *ngIf="sectionTitle">{{ sectionTitle }}</h2>
        <p *ngIf="sectionSubtitle">{{ sectionSubtitle }}</p>
      </div>
      <label class="workflow-search" *ngIf="searchPlaceholder">
        <mat-icon>search</mat-icon>
        <input type="search" [placeholder]="searchPlaceholder" aria-label="Search workflows" />
      </label>
    </header>
  </ng-container>
  <ng-template #standardSectionTitleTpl>
    <h2 *ngIf="sectionTitle" class="content-card-grid-title">{{ sectionTitle }}</h2>
  </ng-template>

  <div
    class="content-card-grid"
    [style.grid-template-columns]="columns"
    [style.gap]="gap"
    [style.max-width]="variant === 'workflow-card-list' ? gridMaxWidth : null">
    <article
      *ngFor="let card of cards"
      class="content-card"
      [class.is-actionable]="hasAction(card)"
      [class.is-disabled]="card.disabled"
      [class.is-workflow-create]="variant === 'workflow-card-list' && card.createCard"
      [ngStyle]="getCardStyle(card)"
      [attr.role]="hasAction(card) ? 'button' : null"
      [attr.tabindex]="hasAction(card) && !card.disabled ? '0' : null"
      (click)="hasAction(card) ? onCardAction(card) : null"
      (keydown)="hasAction(card) ? onCardKeydown($event, card) : null">
    <ng-container *ngIf="variant === 'workflow-card-list'; else nonWorkflowCardTpl">
      <ng-container *ngIf="card.createCard; else workflowCardTpl">
          <div class="workflow-create-card">
            <span class="workflow-create-icon">
              <mat-icon>{{ card.icon || 'add' }}</mat-icon>
            </span>
            <h3>{{ card.title }}</h3>
            <p>{{ card.description }}</p>
          </div>
        </ng-container>

        <ng-template #workflowCardTpl>
          <div class="workflow-badges" *ngIf="card.badges?.length">
            <span
              *ngFor="let badge of card.badges"
              class="workflow-badge"
              [ngClass]="badgeToneClass(badge.tone)">
              {{ badge.label }}
            </span>
          </div>
          <h3 class="workflow-heading">{{ card.title }}</h3>
          <p class="workflow-description">{{ card.description }}</p>
          <div *ngIf="card.detailRows?.length" style="display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 6px 12px; margin: 12px 0 4px; font-size: 11px;">
            <span *ngFor="let row of card.detailRows" style="min-width: 0; color: #5c6573;">
              <strong style="color: #1f2f46;">{{ row.label }}:</strong> {{ row.value }}
            </span>
          </div>
          <div class="workflow-footer">
            <div class="workflow-meta">
              <span *ngFor="let item of card.meta" class="workflow-meta-item">
                <mat-icon>{{ item.icon || 'info' }}</mat-icon>
                {{ item.label }}
              </span>
            </div>
            <span *ngIf="card.version" class="workflow-version">{{ card.version }}</span>
          </div>
        </ng-template>
      </ng-container>

      <ng-template #nonWorkflowCardTpl>
      <ng-container *ngIf="variant === 'operator-home'; else defaultCardTpl">
          <span class="operator-mark tl"></span>
          <span class="operator-mark br"></span>

          <div class="operator-tile-top">
            <span class="operator-icon">
              <mat-icon>{{ card.icon || 'dashboard' }}</mat-icon>
            </span>
            <span class="operator-tag" *ngIf="card.tag; else moduleIdTpl" [class.inactive]="card.disabled">{{ card.tag }}</span>
            <ng-template #moduleIdTpl>
              <span class="operator-module-id">{{ card.moduleId || card.eyebrow }}</span>
            </ng-template>
          </div>

          <h3 class="operator-heading">{{ card.title }}</h3>
          <p class="operator-description">{{ card.description }}</p>
          <div class="operator-status">
            <span class="operator-stat" [class.alert]="cardStatus(card).toLowerCase().includes('pending')">
              <span class="operator-pulse" *ngIf="cardStatus(card).toLowerCase().includes('pending')"></span>
              {{ cardStatus(card) }}
            </span>
            <span *ngIf="hasAction(card)" class="operator-go">
              {{ actionLabel(card) }} <span class="operator-arrow">→</span>
            </span>
          </div>
        </ng-container>
      </ng-template>

      <ng-template #defaultCardTpl>
        <div class="content-card-top"></div>

        <div class="content-card-body">
          <div *ngIf="card.eyebrow" class="content-card-eyebrow">{{ card.eyebrow }}</div>
          <h3 class="content-card-heading">{{ card.title }}</h3>
          <p class="content-card-description">{{ card.description }}</p>
          <span *ngIf="hasAction(card)" class="content-card-link">
            {{ card.action?.label }}
          </span>
        </div>
      </ng-template>
    </article>
  </div>

  <div class="modal-backdrop" *ngIf="showCreateModal" (click)="showCreateModal = false" style="position: fixed; inset: 0; z-index: 10000; display: flex; align-items: center; justify-content: center; padding: 18px; background: rgba(10, 18, 31, 0.48); backdrop-filter: blur(3px);">
    <div class="create-wf-modal" (click)="$event.stopPropagation()" style="width: min(560px, 100%); overflow: hidden; border: 1px solid rgba(21, 35, 54, 0.12); border-radius: 10px; background: #fff; box-shadow: 0 28px 80px rgba(12, 23, 43, 0.28);">
      <div class="modal-hdr" style="display: flex; align-items: flex-start; justify-content: space-between; gap: 18px; padding: 20px 22px 18px; border-bottom: 1px solid #e8edf5; background: linear-gradient(180deg, #ffffff 0%, #f7f9fd 100%);">
        <div style="min-width: 0;">
          <div style="margin-bottom: 6px; color: #54708f; font-size: 11px; font-weight: 800; letter-spacing: 0.08em; text-transform: uppercase;">DOA setup</div>
          <h4 style="margin: 0; color: #122033; font-size: 20px; font-weight: 850; line-height: 1.2;">{{ createWorkflowModal?.title || 'Create Workflow' }}</h4>
          <p style="margin: 8px 0 0; color: #5f6e82; font-size: 13px; line-height: 1.45;">Name the workflow and choose a category before configuring approval nodes.</p>
        </div>
        <button class="modal-close-btn" type="button" aria-label="Close create workflow modal" (click)="showCreateModal = false" style="width: 34px; height: 34px; flex: 0 0 34px; border: 1px solid #d9e1ec; border-radius: 8px; background: #fff; color: #46566a; cursor: pointer; font-size: 18px; line-height: 1;">x</button>
      </div>
      <div class="modal-body" style="display: grid; gap: 16px; padding: 22px;">
        <div class="modal-field" style="display: grid; gap: 7px;">
          <label style="color: #27384d; font-size: 12px; font-weight: 800;">Workflow Name <span class="req" style="color: #c83d4a;">*</span></label>
          <input type="text" [(ngModel)]="newWorkflow.name" placeholder="e.g. Regional Discount DOA" style="width: 100%; min-height: 42px; border: 1px solid #d6deeb; border-radius: 8px; background: #fff; color: #152238; font: inherit; font-size: 14px; outline: 0; padding: 0 12px; box-shadow: inset 0 1px 0 rgba(255,255,255,0.8);" />
        </div>
        <div class="modal-field" style="display: grid; gap: 7px;">
          <label style="color: #27384d; font-size: 12px; font-weight: 800;">Description</label>
          <textarea [(ngModel)]="newWorkflow.description" placeholder="Brief description of what this workflow approves" rows="3" style="width: 100%; min-height: 84px; resize: vertical; border: 1px solid #d6deeb; border-radius: 8px; background: #fff; color: #152238; font: inherit; font-size: 14px; outline: 0; padding: 10px 12px; line-height: 1.45;"></textarea>
        </div>
        <div class="modal-field" style="display: grid; gap: 7px;">
          <label style="color: #27384d; font-size: 12px; font-weight: 800;">Category</label>
          <select [(ngModel)]="newWorkflow.category" style="width: 100%; min-height: 42px; border: 1px solid #d6deeb; border-radius: 8px; background: #fff; color: #152238; font: inherit; font-size: 14px; outline: 0; padding: 0 12px;">
            <option value="General">General</option>
            <option value="Pricing">Pricing</option>
            <option value="Finance">Finance</option>
            <option value="Product">New Product</option>
            <option value="Operations">Operations</option>
          </select>
        </div>
      </div>
      <div class="modal-footer" style="display: flex; align-items: center; justify-content: flex-end; gap: 12px; padding: 16px 22px; border-top: 1px solid #e8edf5; background: #f8fafd;">
        <button class="btn-modal-cancel" type="button" (click)="showCreateModal = false" style="min-height: 38px; border: 1px solid #d6deeb; border-radius: 8px; background: #fff; color: #34445a; cursor: pointer; font-size: 13px; font-weight: 800; padding: 0 16px;">Cancel</button>
        <button class="btn-modal-confirm" type="button" (click)="createWorkflow()" [disabled]="!newWorkflow.name.trim()" style="min-height: 38px; border: 1px solid #043D63; border-radius: 8px; background: #043D63; color: #fff; cursor: pointer; font-size: 13px; font-weight: 850; padding: 0 18px;">Create & Configure</button>
      </div>
    </div>
  </div>
</section>


